import React, { useEffect } from "react";
import SkyClear from "../../img/HeaderSkyClear.png";
import fotoMapa from "../../img/fotoMapa.png";

interface HeaderProps {
  titulo: string;
  // FV: string;
  // NV: string;
  // C: string;
}

const Encabezado: React.FC<HeaderProps> = ({ titulo }) => {
  useEffect(() => {
    const headerContent = document.getElementById("headerContent");
    if (headerContent) {
      headerContent.classList.add(
        "opacity-100",
        "translate-y-0",
        "transition-all",
        "duration-1000"
      );
    }
  }, []);

  return (
    <>
      {/* Encabezado con la imagen */}
      <div className="bg-customBlue text-white p-4 flex justify-between items-center relative overflow-hidden">
        <img
          src={SkyClear}
          alt="Encabezado SkyClear"
          className="absolute top-0 left-0 w-full h-full object-cover transform transition-transform duration-1000 ease-in-out hover:scale-105"
        />
        <div className="text-right text-sm absolute top-4 bottom-4 right-4 z-10 text-white font-bold">
          <p className="mb-1">Fecha de versión: </p>
          <p className="mb-1">No. de versión: </p>
          <p>Código: </p>
        </div>
        <div className="text-right text-sm relative z-10">
        <div className="mt-[75px]"></div>
        </div>
      </div>
      {/* Título del formulario */}
      <div
        id="headerContent"
        className="text-center opacity-0 transform transition-all duration-1000 ease-out"
      >
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {titulo}
        </h1>
      </div>
    </>
  );
};

export default Encabezado;
